module.exports = " <div class=action_bar _v-6671729c=\"\"> <span class=hint _v-6671729c=\"\">按下Ctrl+Enter换行</span> <button @click=sendArbiter _v-6671729c=\"\">发送</button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6671729c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/session/ActionBar.vue
 ** module id = 352
 ** module chunks = 2
 **/